import { z } from 'zod';

export const CheckSnsDuplicateServiceRequestSchema = z.object({
  url: z.string().min(1),
});

export const CheckSnsDuplicateServiceResponseSchema = z.object({
  isDuplicated: z.boolean(),
  duplicatedUrls: z.array(z.string()),
  message: z.string(),
});

export type CheckSnsDuplicateServiceRequest = z.infer<typeof CheckSnsDuplicateServiceRequestSchema>;

export type CheckSnsDuplicateServiceResponse = z.infer<
  typeof CheckSnsDuplicateServiceResponseSchema
>;
